import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../utilities/requestClient';
import { FundAssetLiquidationTimeData } from './fund-asset-liquidation.types';
import { RSFundPageModel } from '../../../../types/server-data/ClientConfig';

export function useFundAssetLiquidation(
  fundId: string,
  positionDate: string | undefined,
) {
  return useQuery({
    queryKey: ['fund-asset-liquidation-time-data', fundId, positionDate],
    queryFn: () => fetchFundAssetLiquidationData(fundId, positionDate!),
    enabled: !!fundId && !!positionDate,
    staleTime: 1000 * 60 * 5,
  });
}

async function fetchFundAssetLiquidationData(
  fundId: string,
  positionDate: string,
) {
  const url = `agg_liquidation_zone_inc_cash/${fundId}/${positionDate}`;
  const { data } =
    await AxiosInstance.get<RSFundPageModel<FundAssetLiquidationTimeData>>(url);
  return data;
}
